module.exports = "/_next/static/images/stamprallybanner-2653925925a594ee707e3c41c937294b.jpg";